import { useNavigate } from "react-router-dom";
import { Form, Input, Button, Typography, Flex, theme, Row, Col, Card, Divider } from "antd";
import {
  MailOutlined,
  LockOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
} from "@ant-design/icons";
import { useLogin } from "../hooks/useLogin";
import openNotification from '../../../utils/openNotification'
import { lsSelectedCompany } from '../../../constans/auth'

const { Title, Text } = Typography;
// Standard elegant background image for the cover

const LoginPage = () => {
  const navigate = useNavigate();
  const { token } = theme.useToken();
  const [form] = Form.useForm();
  const loginMutation = useLogin();

  const onFinish = (values: { email: string; password: string }) => {
    loginMutation.mutate(values, {
      onSuccess: () => {
        // Remove from local storage
        localStorage.removeItem(lsSelectedCompany);
        navigate("/dashboard");
      },
      onError: (error) => {
        openNotification('error', `Error`, error.message);
      },
    });
  };

  const handleCreateAccount = () => {
    navigate("/signUp");
  };

  return (
    <Row style={{ minHeight: "100vh", background: token.colorBgLayout }}>
      {/* Image Side - Hidden on Mobile */}
      <Col xs={0} lg={14} style={{
        backgroundImage: `url('${LOGIN_BG_URL}')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative"
      }}>
      </Col>

      {/* Form Side */}
      <Col xs={24} lg={10}>
        <Flex justify="center" align="center"
          style={{
            minHeight: "100vh",
            padding: token.padding,
          }}
        >
          <Card
            bordered={false}
            style={{
              width: "100%",
              maxWidth: "420px",
              boxShadow: "none",
              border: `1px solid ${token.colorBorderSecondary}`,
              borderRadius: "12px",
              backgroundColor: token.colorBgContainer,
            }}
            styles={{
              body: {
                padding: token.paddingXL
              }
            }}
          >
            <Flex vertical gap="large">
              <div style={{ textAlign: "center", marginBottom: 8 }}>
                <Text type="secondary" style={{ letterSpacing: "2px", fontSize: "0.85rem", fontWeight: 700, display: "block", marginBottom: 4 }}>
                  {APP_NAME}
                </Text>
                <Title level={2} style={{ margin: 0, fontWeight: 800 }}>Bienvenido</Title>
                <Text type="secondary">Inicia sesión en tu cuenta</Text>
              </div>

              <Form form={form} name="login" layout="vertical" onFinish={onFinish} size="large" requiredMark={false}>
                <Form.Item
                  label={<Text strong style={{ fontSize: 13, color: token.colorTextSecondary }}>Correo Electrónico</Text>}
                  name="email"
                  rules={[
                    { required: true, message: "Por favor ingresa tu correo electrónico." },
                    { type: "email", message: "El correo no es válido." },
                  ]}
                >
                  <Input
                    prefix={<MailOutlined style={{ color: token.colorTextQuaternary, marginRight: 8 }} />}
                    placeholder="ejemplo@correo.com"
                    style={{ borderRadius: 8, backgroundColor: token.colorBgLayout }}
                  />
                </Form.Item>

                <Form.Item
                  label={<Text strong style={{ fontSize: 13, color: token.colorTextSecondary }}>Contraseña</Text>}
                  name="pass"
                  rules={[
                    {
                      required: true,
                      message: "Por favor ingresa tu contraseña.",
                    },
                    {
                      min: 6,
                      message: "Mínimo 6 caracteres.",
                    },
                  ]}
                >
                  <Input.Password
                    prefix={<LockOutlined style={{ color: token.colorTextQuaternary, marginRight: 8 }} />}
                    placeholder="Ingresa tu contraseña"
                    style={{ borderRadius: 8, backgroundColor: token.colorBgLayout }}
                    iconRender={(visible) => visible ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                  />
                </Form.Item>

                <Flex justify="flex-end" style={{ marginTop: "-16px", marginBottom: "24px" }}>
                  <Typography.Link href="#" style={{ fontSize: "13px", fontWeight: 600, color: token.colorPrimary }}>
                    ¿Olvidaste tu contraseña?
                  </Typography.Link>
                </Flex>

                <Form.Item style={{ marginBottom: 0 }}>
                  <Button type="primary" htmlType="submit" block loading={loginMutation.isPending} style={{ height: 48, borderRadius: 8, fontWeight: 700 }}>
                    Ingresar
                  </Button>
                </Form.Item>
              </Form>

              <Divider plain style={{ margin: "16px 0", color: token.colorTextPlaceholder }}>¿No tienes cuenta?</Divider>

              <Button type="default" block size="large" onClick={handleCreateAccount} style={{ height: 48, borderRadius: 8, fontWeight: 600, color: token.colorPrimary, borderColor: token.colorPrimary }}>
                Crear cuenta
              </Button>
            </Flex>
          </Card>
        </Flex>
      </Col>
    </Row>
  );
};

export default LoginPage;
